import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/UserLogin.vue'
import Register from '../views/UserRegister.vue'
import AdminAnalyze from '../views/AdminAnalyze.vue'
import AdminUsers from '../views/AdminUsers.vue'
import AdminOrders from '../views/AdminOrders.vue'
import UserOrders from '../views/UserOrders.vue'
import Order from "@/views/OrderContainer.vue";
import SuperMaster from "@/views/SuperMaster.vue";
import AssignAstigmatism from "@/views/AssignAstigmatism.vue";
import BulkOrders from "@/views/BulkOrders.vue";
import UserInfo from "@/views/UserInfo.vue";
import Mail from "@/views/MailPage.vue";
import OrderProcessing from "@/views/OrderProcessing.vue";
import AdController from "@/views/AdController.vue";
import ModelManagement from "@/views/ModelManagement.vue";
import InspectionManagement from "@/views/InspectionManagement.vue";
import AuditCenter from "@/views/AuditCenter.vue";


const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登陆页面',
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/user/info',
    name: 'UserInfo',
    component: UserInfo,
    meta: { requiresAuth: true,title: '个人信息' }
  },
  {
    path: '/mail',
    name: 'Mail',
    component: Mail,
    meta: { requiresAuth: true,title: '物流查询' }
  },
  {
    path: '/admin/analyze',
    name: 'AdminAnalyze',
    component: AdminAnalyze,
    meta: { requiresAuth: true, requiresAdmin: true ,title: '用户状况分析'}
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    component: AdminUsers,
    meta: { requiresAuth: true, requiresAdmin: true ,title: '用户管理'}
  },
  {
    path: '/order',
    name: 'Order',
    component: Order,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'OrderDefault',
        redirect: () => {
          const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
          return userInfo.role === 'ADMIN' ? '/admin/orders' : '/user/orders';
        }
      },
      {
        path: '/admin/orders',
        name: 'AdminOrders',
        component: AdminOrders,
        meta: { requiresAuth: true, requiresAdmin: true,title: '管理员订单管理' }
      },
      {
        path: '/user/orders',
        name: 'UserOrders',
        component: UserOrders,
        meta: { requiresAuth: true,title: '用户订单管理' }
      },
      {
        path: '/supermaster',
        name: 'SuperMaster',
        component: SuperMaster,
        meta: { requiresAuth: true ,title: '超主点订单下单'}
      },
      {
        path: '/astigmatism',
        name: 'Astigmatism',
        component: AssignAstigmatism,
        meta: { requiresAuth: true ,title: '散像散订单下单'}
      },
      {
        path: '/bulkorders',
        name: 'BulkOrders',
        component: BulkOrders,
        meta: { requiresAuth: true,title: '批量订单下单'}
      }
      ,{
        path: '/orderprocessing',
        name: 'OrderProcessing',
        component: OrderProcessing,
        meta: { requiresAuth: true ,title: '订单处理'}
      }
      ,{
        path: '/ad',
        name: 'AdController',
        component: AdController,
        meta: { requiresAuth: true ,title: '广告控制面板'}
      }
      ,{
        path:'/model',
        name:'ModelManagement',
        component:ModelManagement,
        meta: { requiresAuth: true, requiresAdmin: true, title: '型号管理'}
      },
      {
        path:'/unit',
        name:'UnitManagement',
        component:InspectionManagement,
        meta: { requiresAuth: true, title: '验配单位管理'}
      },
      {
        path:'/admin/audit',
        name:'AuditCenter',
        component:AuditCenter,
        meta: { requiresAuth: true, requiresAdmin: true, title: '操作日志与审计中心' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const title = to.meta?.title

  if (title) {
    document.title = title
  }

  const userInfoStr = localStorage.getItem('userInfo');
  
  // 如果是登录或注册页面，直接放行
  if (to.path === '/login' || to.path === '/register') {
    next();
    return;
  }
  
  // 如果没有用户信息，跳转到登录页
  if (!userInfoStr) {
    next('/login');
    return;
  }
  
  try {
    const userInfo = JSON.parse(userInfoStr);
    const isAdmin = userInfo.role === 'ADMIN';
    
    // 检查路由是否需要管理员权限
    const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
    
    // 如果需要管理员权限但用户不是管理员
    if (requiresAdmin && !isAdmin) {
      next('/user/orders');
      return;
    }
    
    // 如果是管理员访问用户路由（除了个人信息页面）
    if (isAdmin && to.path.startsWith('/user') && to.path !== '/user/info') {
      next('/admin/orders');
      return;
    }
    
    // 如果是普通用户访问管理员路由
    if (!isAdmin && to.path.startsWith('/admin')) {
      next('/user/orders');
      return;
    }
    
    // 登录成功后，访问根路径时自动跳转到订单页面
    if (to.path === '/') {
      next('/order');
      return;
    }
    
    // 其他情况正常访问
    next();
  } catch (error) {
    console.error('路由守卫错误:', error);
    // 如果解析用户信息出错，清除登录状态并跳转到登录页
    localStorage.clear();
    next('/login');
  }
});

export default router
